import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { SecondStepForm } from 'shared/components/SecondStepForm';
import { useAppDispatch } from 'shared/hooks';
import { selectFormFormFields, selectFormPriceRange, selectFormStatus } from 'shared/selectors/form';
import { setModalStatus } from 'shared/slices';
import { sendForm } from 'shared/thunks';
import { EStatus } from 'shared/types/form';
import { EModalStatus } from 'shared/types/modal';

export const SecondStepFormContainer: React.FC = () => {
  const [selectedChips, setSelectedChips] = useState<string[]>([]);

  const formStatus = useSelector(selectFormStatus);

  const { phone, address } = useSelector(selectFormFormFields);

  const priceRange = useSelector(selectFormPriceRange);

  const [chipsError, setChipsError] = useState<string>();

  const [price, setPrice] = useState<number>();

  const [priceAdornment, setPriceAdornment] = useState('мес');

  const [priceError, setPriceError] = useState<string>();

  const dispatch = useAppDispatch();

  const handleSelectedChips = useCallback(
    (value: string[]) => {
      setSelectedChips(value);

      if (value[0] === 'Посуточно') {
        setPriceAdornment('сут');
      } else {
        setPriceAdornment('мес');
      }

      if (priceError) {
        setChipsError(undefined);
      }
    },
    [priceError],
  );

  const handlePrice = useCallback(
    (value: number) => {
      setPrice(value);

      if (priceError) {
        setPriceError(undefined);
      }
    },
    [priceError],
  );

  const handleBtnNext = useCallback(async () => {
    let isError = false;

    if (selectedChips.length === 0) {
      setChipsError('Укажите срок аренды');
      isError = true;
    }

    if (!price) {
      setPriceError('Укажите сумму аренды');
      isError = true;
    }

    if (
      selectedChips.length > 0 &&
      selectedChips[0] === 'От года' &&
      price &&
      price > priceRange[0] &&
      price < priceRange[1]
    ) {
      await dispatch(sendForm({ price, leaseTermType: selectedChips[0], phone, address }));
    } else if (!isError) {
      dispatch(
        setModalStatus({
          status: EModalStatus.Failed,
          error: {
            title: 'К сожалению, не сможем помочь',
            description:
              'Параметры квартиры не подходят под условия сервиса. Вы можете разместить объявление о сдаче на Циане самостоятельно',
          },
        }),
      );
    }
  }, [address, dispatch, phone, price, priceRange, selectedChips]);

  return (
    <SecondStepForm
      price={price}
      priceAdornment={priceAdornment}
      priceError={priceError}
      isLoading={formStatus === EStatus.Loading}
      chipsError={chipsError}
      selectedChips={selectedChips}
      onBtnNext={handleBtnNext}
      onChangePrice={handlePrice}
      onChangeSelectedChips={handleSelectedChips}
    />
  );
};
